/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiExportFileType {
    CSV = 'CSV',
    XLSX = 'XLSX'
}


export function instanceOfInternalApiExportFileType(value: any): boolean {
    for (const key in InternalApiExportFileType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiExportFileType, key)) {
            if (InternalApiExportFileType[key as keyof typeof InternalApiExportFileType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiExportFileTypeFromJSON(json: any): InternalApiExportFileType {
    return InternalApiExportFileTypeFromJSONTyped(json, false);
}

export function InternalApiExportFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiExportFileType {
    return json as InternalApiExportFileType;
}

export function InternalApiExportFileTypeToJSON(value?: InternalApiExportFileType | null): any {
    return value as any;
}

export function InternalApiExportFileTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiExportFileType {
    return value as InternalApiExportFileType;
}

